import React from 'react';

const Select = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <select
      className={`flex h-10 w-full rounded-lg border border-line-strong bg-elev px-3 py-2 text-base text-fg focus-visible:outline-none focus-visible:border-fg-3 disabled:cursor-not-allowed disabled:opacity-50 dark-select ${className || ''}`}
      ref={ref}
      {...props}
    >
      {children}
    </select>
  );
});

Select.displayName = "Select";

export { Select };
